export const Trigger = (name, data = null) => document.dispatchEvent(new CustomEvent(name, { detail: data }));

export const Listener = (name, handler) => {
	const fn = (evt) => handler(evt.detail);
	document.addEventListener(name, fn);
	// Return function to unbind listener 
	return () => document.removeEventListener(name, fn);
};

export const UnbindListener = (listener) => {
	// Unbind an array of multiple listeners
	if (Array.isArray(listener)) {
		return listener.forEach(unbindFn => unbindFn());
	}
	// Unbind single listener
	if (typeof listener === 'function') {
		return listener();
	}
};